import { Checkbox } from 'antd'
import Checkboxes from 'components/Form/Checkbox'
import styled from 'styled-components'

export const StyledGroup = styled(Checkbox.Group)`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`
export const StyledCheckbox = styled(Checkboxes)`
  margin-left: 0 !important;
  padding: 10px !important;
  display: ${props => props.showFromStart && 'flex'};
  align-items: ${props => props.showFromStart && 'flex-start'};
`
export const StyledCheckbox1 = styled(Checkboxes)`
  margin-left: 0 !important;
  padding: 10px !important;

  .ant-checkbox-inner {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 24px !important;
    height: 24px !important;
    direction: ltr;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    border-collapse: separate;
    transition: all 0.3s;
  }
`
